// src/pages/AdminDashboard.js
import React, { useState, useEffect } from 'react';
import apiClient from '../services/api';
import { io } from 'socket.io-client'; // 🔥 NAYA IMPORT

// 🔥 SOCKET URL (Backend ka address)
const SOCKET_URL = 'https://pickupdrop.dodigitals.in'; 

const AdminDashboard = () => {
  const [vendors, setVendors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  const [totalVendorsCount, setTotalVendorsCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0); 
  const [liveCount, setLiveCount] = useState(0);         

  // 🔥 NAYE STATES USERS KE LIYE 🔥
  const [totalUsersCount, setTotalUsersCount] = useState(0);
  const [liveAppUsers, setLiveAppUsers] = useState(0); // Socket se aayega

  const [dashboardStats] = useState({ todayEarnings: 12450 });

  const fetchAllData = async () => {
    try {
      const cacheBuster = new Date().getTime();
      
      // 1. Fetch Vendors Data
      const pendingRes = await apiClient.get(`/admin/vendors/pending?_t=${cacheBuster}`);
      setVendors(pendingRes.data.vendors);

      const allRes = await apiClient.get(`/admin/vendors/all?_t=${cacheBuster}`);
      const allVendorsList = allRes.data.vendors;
      
      setTotalVendorsCount(allVendorsList.length);

      const approvedVendors = allVendorsList.filter(vendor => vendor.isProfileVerified === true);
      setApprovedCount(approvedVendors.length);

      const liveVendors = approvedVendors.filter(vendor => vendor.isOnline === true);
      setLiveCount(liveVendors.length);

      // 🔥 2. NAYA: Fetch Total Users Data 🔥
      const usersRes = await apiClient.get(`/admin/users/all?_t=${cacheBuster}`);
      setTotalUsersCount(usersRes.data.totalCount || usersRes.data.users?.length || 0);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
      setIsRefreshing(false);
    }
  };

  // 🔄 Data Fetching Effect
  useEffect(() => {
    fetchAllData();
    const intervalId = setInterval(() => {
      if (!isRefreshing) fetchAllData(); 
    }, 15000); 
    return () => clearInterval(intervalId);
  }, [isRefreshing]); 

  // 🚀 NAYA: SOCKET.IO EFFECT (Live Users Tracking) 🚀
  useEffect(() => {
    const socket = io(SOCKET_URL);

    socket.on('connect', () => {
      console.log('✅ Admin Panel Connected to Socket!');
    });

    // Backend se aayi hui live ginti yahan set hogi
    socket.on('liveUsersUpdate', (count) => {
      setLiveAppUsers(count);
    });

    return () => {
      socket.disconnect(); // Admin panel band ho toh disconnect
    };
  }, []);

  const handleRefresh = () => {
    setIsRefreshing(true);
    fetchAllData();
  };

  const handleApprove = async (vendorId, shopName) => {
    const confirmApproval = window.confirm(`Confirm approval for ${shopName}?`);
    if (!confirmApproval) return;

    try {
      await apiClient.put(`/admin/vendors/approve/${vendorId}`);
      setVendors((prevVendors) => prevVendors.filter(vendor => vendor._id !== vendorId));
      setApprovedCount(prev => prev + 1);
    } catch (error) {
      alert("Failed to process approval.");
    }
  };

  if (isLoading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
        <p>Loading Workspace...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-wrapper">
      <div className="page-header">
        <div>
          <h1 className="page-title">Dashboard</h1>
          <p className="page-desc">Manage your business & approvals.</p>
        </div>
        <button className="refresh-btn" onClick={handleRefresh} disabled={isRefreshing}>
          {isRefreshing ? "⏳ Syncing..." : "🔄 Refresh Data"}
        </button>
      </div>

      {/* 🔥 GRID MEIN AB 6 CARDS HAIN 🔥 */}
      <div className="dashboard-stats-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}>
        
        {/* Card 1: Pending */}
        <div className="stat-card">
          <h3 className="stat-title">Pending Approvals</h3>
          <p className="stat-value" style={{ color: '#ea6724' }}>{vendors.length}</p>
          <div className="stat-trend trend-neutral">Action required</div>
        </div>
        
        {/* Card 2: Total Stores */}
        <div className="stat-card">
          <h3 className="stat-title">Total Registered</h3>
          <p className="stat-value">{totalVendorsCount}</p>
          <div className="stat-trend trend-neutral">Vendor Accounts</div>
        </div>
        
        {/* Card 3: Live Stores */}
        <div className="stat-card">
          <h3 className="stat-title">Live & Approved Stores</h3>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', marginBottom: '8px' }}>
            <p className="stat-value" style={{ margin: 0, color: '#22c55e' }}>{liveCount}</p>
            <span style={{ fontSize: '15px', fontWeight: '700', color: '#1b254b', paddingBottom: '5px' }}>Live</span>
          </div>
          <div className="stat-trend trend-neutral">
            Out of {approvedCount} total approved
          </div>
        </div>

        {/* 🔥 NAYA CARD 4: Total Customers 🔥 */}
        <div className="stat-card">
          <h3 className="stat-title">Total Customers</h3>
          <p className="stat-value" style={{ color: '#355ca9' }}>{totalUsersCount}</p>
          <div className="stat-trend trend-neutral">App Registered Users</div>
        </div>

        {/* 🔥 NAYA CARD 5: Live App Users (Socket) 🔥 */}
        <div className="stat-card" style={{ border: '1px solid #dcfce7', backgroundColor: '#f0fdf4' }}>
          <h3 className="stat-title">Live App Users</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
            {/* Blinking Green Dot */}
            <div style={{ width: 14, height: 14, borderRadius: '50%', backgroundColor: '#22c55e', boxShadow: '0 0 10px #22c55e' }}></div>
            <p className="stat-value" style={{ margin: 0, color: '#16a34a' }}>{liveAppUsers}</p>
          </div>
          <div className="stat-trend trend-neutral" style={{ color: '#15803d' }}>Currently browsing the app</div>
        </div>
        
        {/* Card 6: Revenue */}
        <div className="stat-card">
          <h3 className="stat-title">Today's Revenue</h3>
          <p className="stat-value">₹{dashboardStats.todayEarnings.toLocaleString('en-IN')}</p>
          <div className="stat-trend trend-neutral">Updated today</div>
        </div>
      </div>

      <div className="data-card">
        <div className="table-header-bar">
          <h3 className="table-title">Action Needed: Pending Registrations</h3>
          {vendors.length > 0 && <span className="badge-count">{vendors.length} New</span>}
        </div>

        {vendors.length === 0 ? (
          <div className="empty-state">
            <h3 style={{ margin: '0 0 8px 0', color: '#1b254b' }}>🎉 Inbox Zero</h3>
            <p style={{ margin: 0, color: '#8f9fc2' }}>All reviews are complete.</p>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="modern-table">
              <thead>
                <tr>
                  <th>Store Details</th>
                  <th>Location</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {vendors.map((vendor) => (
                  <tr key={vendor._id}>
                    <td>
                      <div className="vendor-info" style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="vendor-avatar" style={{width: '36px', height: '36px', borderRadius: '50%', background: '#f4f7fe', color: '#355ca9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', marginRight: '12px'}}>
                          {vendor.shopName.charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <div className="vendor-name">{vendor.shopName}</div>
                          <div className="vendor-sub">{vendor.name} • {vendor.phone}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ maxWidth: '280px' }}>
                      <div className="vendor-location-wrap" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        <div style={{ color: '#1b254b', fontWeight: '600' }} className="vendor-location-text">
                          {vendor.location?.address || 'N/A'}
                        </div>
                        <div className="vendor-sub">PIN: {vendor.pincode}</div>
                      </div>
                    </td>
                    <td>
                      <span className="status-badge">Review Pending</span>
                    </td>
                    <td>
                      <button className="action-btn" onClick={() => handleApprove(vendor._id, vendor.shopName)}>
                        Approve
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;